import * as moment from 'moment'
import * as React from 'react'
import { IRiderObject } from '../../../../types'
import TeamMemberDefault from '../../../icons/ui/TeamMemberDefault'
import UIMessages from '../../../../utils/ui-messages'
import ImageView from '../../../ui/ImageView'
import { maskPhoneNumber } from '../../../../utils/mask'
import Toggle from 'src/components/ui/Toggle'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import { Switch } from '@mobiscroll/react-latest'
import FormLabel from 'src/components/ui/form/FormLabel'

interface IPersonalInfoPaneProps {
  rider: IRiderObject
}
class PersonalInfoPane extends React.Component<IPersonalInfoPaneProps, any> {
  constructor(props: IPersonalInfoPaneProps) {
    super(props)
  }

  public render() {
    const { rider } = this.props
    if (!rider) {
      return null
    }

    const phoneCountryCode = '+' + rider.countryCode

    let phoneNumber = ''
    if (rider.phone ? rider.phone.indexOf(rider.countryCode) === 0 : false) {
      phoneNumber = maskPhoneNumber(rider.phone ? rider.phone.replace(rider.countryCode, '') : '')
    } else {
      phoneNumber = maskPhoneNumber(rider.phone ? rider.phone : '')
    }

    const caregiverPhoneNumber =
      rider.caregiver && rider.caregiver.countryCode
        ? `${rider.caregiver.countryCode}${rider.caregiver.contactNumber}`
        : ''

    const date = rider.birthDate ? rider.birthDate.split('T')[0] : null
    const birthdate = date
      ? moment(date)
          .format('MMMM DD, YYYY')
          .toString()
      : 'N/A'

    return (
      <FloatingForm fullHeight={true}>
        <>
          <div className='form-modal-section main-section'>
            <div className='flex'>
              <FormLabel>Personal Information</FormLabel>
            </div>

            <div className='bb-shadow-grey'>&nbsp;</div>

            <div style={{ height: '82px' }} className='flex flex-row'>
              <div className='flex flex-column justify-center'>
                <ImageView name={`${rider.firstName} ${rider.lastName}`} entityId={rider.id} isRounded={true} />
              </div>
              <div className='ml2 flex flex-column justify-center'>
                <div>
                  <span className='RiderDetailsFirstName h5'>{rider.firstName}</span>{' '}
                  <span className='h5'>{rider.lastName}</span>
                </div>
                <div className='h5'>{birthdate}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.email}</FormLabel>
                <div className='mt1 h5'>{rider.email || 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.phoneNumber}</FormLabel>
                <div className='mt1 h5'>
                  {phoneCountryCode !== '0' && phoneNumber !== '+' && phoneNumber !== '' ? `${phoneCountryCode} ` : ''}
                  {phoneNumber || 'None'}
                </div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.username}</FormLabel>
                <div className='mt1 h5'>{rider.username || 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.riderProfileNote}</FormLabel>
                <div className='mt1 h5'>{rider.note || 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.riderProfileInternalNote}</FormLabel>
                <div className='mt1 h5'>{rider.internalNote || 'None'} </div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>Orca Serial Number</FormLabel>
                <div className='mt1 h5'>{rider.orcaSerialNumber || 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>Rider Referral Code</FormLabel>
                <div className='mt1 h5'>{rider.riderReferralCode || 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>Preferred Payment Method</FormLabel>
                <div className='mt1 h5'>{rider.paymentMode || 'None'}</div>
              </div>
            </div>
          </div>
          <div className='form-modal-section sub-section'>
            <div className='flex'>
              <FormLabel>Mobile Settings</FormLabel>
            </div>

            <div className='bb-shadow-grey'>&nbsp;</div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>Dark Mode</FormLabel>
                <Switch checked={rider.darkmode ? rider.darkmode : false} disabled={true} position='start' />
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>Disable Mobile Booking</FormLabel>
                <Switch checked={rider.disableMobileBooking} disabled={true} position='start' />
              </div>
            </div>

            <div className='bb-shadow-grey'>&nbsp;</div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.notificationSetting}</FormLabel>
                <div className='mt1 h5'>{rider.notificationPreference || 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>Profile External Id</FormLabel>
                <div className='mt1 h5'>{rider.externalId || 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt2'>
                <FormLabel>Caregiver Information</FormLabel>
              </div>
            </div>
            <div className='bb-shadow-grey'>&nbsp;</div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.firstName}</FormLabel>
                <div className='mt1 h5'>{rider.caregiver ? rider.caregiver.firstName : 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.lastName}</FormLabel>
                <div className='mt1 h5'>{rider.caregiver ? rider.caregiver.lastName : 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.relationship}</FormLabel>
                <div className='mt1 h5'>{rider.caregiver ? rider.caregiver.relationship : 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.phoneNumber}</FormLabel>
                <div className='mt1 h5'>{rider.caregiver ? caregiverPhoneNumber : 'None'}</div>
              </div>
            </div>

            <div className='flex flex-row'>
              <div style={{ flex: 1 }} className='mt1'>
                <FormLabel>{UIMessages.common.email}</FormLabel>
                <div className='mt1 h5'>{rider.caregiver ? rider.caregiver.emailAddress : 'None'}</div>
              </div>
            </div>
          </div>
        </>
      </FloatingForm>
    )
  }
}

export default PersonalInfoPane



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/personalinfo/PersonalInfoPane.tsx